import { RegisterPanelContainer } from "../../login/ui"

export default function Page(props) {
  return <RegisterPanelContainer {...props} />
}